import React, { useRef, useCallback } from 'react';

const Step1_Details = ({ data, updateData, isLocked, isEditMode, tournamentId, authenticatedFetch }) => {
    const lastSavedNameRef = useRef(data.name);
    const isStarted = isLocked || data.courses?.some(c => c.is_started);

    const handleNameBlur = useCallback(async (e) => {
        const newName = e.target.value;
        if (!isEditMode || !tournamentId) return;
        if (newName === lastSavedNameRef.current) return;

        try {
            await authenticatedFetch(`/tournaments/${tournamentId}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ name: newName }),
            });
            lastSavedNameRef.current = newName;
        } catch (error) {
            console.error('Failed to auto-save tournament name:', error);
        }
    }, [isEditMode, tournamentId, authenticatedFetch]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        updateData({ [name]: value });
    };

    const formatHumanDate = (dateStr) => {
        if (!dateStr) return 'Select Date';
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-GB', {
            weekday: 'short', day: 'numeric', month: 'short', year: 'numeric'
        });
    };

    return (
        <div className="wiz-step">
            <h2 className="wiz-header">What's this tournament called?</h2>
            <p className="wiz-subtitle">Give it a name your players will recognise.</p>

            {isStarted && (
                <div className="wiz-locked-banner">
                    Scoring has started — some settings are locked
                </div>
            )}

            <div className="wiz-field">
                <label htmlFor="name" className="wiz-label">Tournament Name</label>
                <input
                    type="text"
                    id="name"
                    name="name"
                    className="wiz-input wiz-input--hero"
                    placeholder="The Summer Classic"
                    value={data.name}
                    onChange={handleInputChange}
                    onBlur={handleNameBlur}
                />
            </div>

            <div className="wiz-field">
                <label htmlFor="date" className="wiz-label">Date</label>
                <div className="wiz-date">
                    <input
                        type="date"
                        id="date"
                        name="date"
                        value={data.date}
                        onChange={handleInputChange}
                        className="wiz-date__native"
                    />
                    <span className="wiz-date__overlay">
                        {formatHumanDate(data.date)}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default Step1_Details;
